<template>
    <modal
        class="regulations-modal modal-without-footer"
        name="regulations-modal"
        transition="fade"
        :adaptive="true"
        :scrollable="true"
        :reset="true"
        width="70%"
        height="80%"
        style="z-index: 1001"
    >
        <div id="modal-header">
            <div class="w-75 d-flex">
                <p>iTender մրցույթների կանոնակարգ</p>
            </div>
            <button
                type="button"
                class="close position-absolute"
                style="right: 1.25rem; top: 25%"
                @click="$modal.hide('regulations-modal')"
                aria-label="Close"
            >
                <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16.5 1.64102L14.859 0L8.49997 6.359L2.14102 4.62582e-05L0.5 1.64107L6.85895 8.00002L0.500034 14.3589L2.14105 16L8.49997 9.64104L14.8589 16L16.5 14.359L10.141 8.00002L16.5 1.64102Z"
                        fill="#ABAEB8"
                    />
                </svg>
            </button>
        </div>
        <div id="modal-body" class="regulations-body">
            <regulations />
        </div>
    </modal>
</template>

<script>
import Regulations from './Regulations.vue'

export default {
    name: 'RegulationsModal',
    components: {
        Regulations,
    },
}
</script>

<style scoped>
.regulations-modal {
    z-index: 2001;
}

.regulations-body {
    padding: 0;
    overflow-y: auto;
    height: calc(100% - 60px);
}
</style>
